import { selectCognitoUserObject } from 'utils/cognito.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { isEnvCy } from 'utils/env/determine.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isFn from 'utils/predicates/function/isFn.util';

import AT from './confirmRegistration.type';

const L = logger('confirmRegistration');

// noinspection DuplicatedCode
const mockConfirmRegistration = () => (dispatch) => {
  const data = '';

  dispatch(L.debug('mockConfirmRegistration()', 'init:', { type: AT.init }));
  dispatch(L.debug('mockConfirmRegistration()', 'pass:', { type: AT.pass, data }));
  dispatch(L.debug('mockConfirmRegistration()', 'done:', { type: AT.done }));

  return Promise.resolve(data);
};

// FIXME: mocking should be part of the Cypress tests not the regular code
const confirmRegistration = isEnvCy()
  ? mockConfirmRegistration
  : (options) => (dispatch, getState) => {
      // SEE: https://www.npmjs.com/package/amazon-cognito-identity-js
      // SEE: https://github.com/aws-amplify/amplify-js

      const { code, forceAliasCreation = true } = asObject(options);
      dispatch({ type: AT.init });

      const user = selectCognitoUserObject(getState());
      const confirmationCode = Array.isArray(code) ? code.join('') : fromAnyToString(code);

      const promise = new Promise((resolve, reject) => {
        try {
          if (isFn(user && user.confirmRegistration)) {
            // SEE: node_modules/amazon-cognito-identity-js/index.d.ts
            user.confirmRegistration(confirmationCode, forceAliasCreation, (error, result) =>
              error ? reject(error) : resolve(result),
            );
          } else {
            reject(new Error("Can't verify, maybe not logged in or invalid user:", user));
          }
        } catch (e) {
          reject(e);
        }
      });

      promise
        .then((d) => dispatch({ type: AT.pass, data: L.debug('()', 'then()', d) }))
        .catch((e) => dispatch({ type: AT.fail, data: L.warn('()', 'catch()', { code, user }, e) }))
        .finally(() => dispatch({ type: AT.done }));

      return promise;
    };

// noinspection JSUnusedGlobalSymbols
export default confirmRegistration;
